import http from '../const/http-common'

const getUsers = (userInfo) => {
  return http.post('/v1/users/get-list', userInfo);
}

const createUser = (userInfo) => {
  return http.post('/v1/users/create', userInfo);
}

const updateUser = (userInfo) => {
  return http.post('/v1/users/update', userInfo);
}

const deleteUser = (id) => {
  return http.delete(`/v1/users/${id}/delete`);
}

const assignSourceToUser = (info) => {
  return http.post(`/v1/users/assign`);
}

const userService = {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  assignSourceToUser
}

export default userService